import { render } from "./DIYProductModal.vue?vue&type=template&id=53c77b33&scoped=true"
import script from "./DIYProductModal.vue?vue&type=script&lang=js"
export * from "./DIYProductModal.vue?vue&type=script&lang=js"

import "./DIYProductModal.vue?vue&type=style&index=0&id=53c77b33&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c77b33"]])

export default __exports__